import { render, staticRenderFns } from "./sk-textarea.vue?vue&type=template&id=cd46c10c&"
import script from "./sk-textarea.vue?vue&type=script&lang=js&"
export * from "./sk-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports